import { render, staticRenderFns } from "./NavigatorMain.vue?vue&type=template&id=3fc4a433&scoped=true&"
import script from "./NavigatorMain.vue?vue&type=script&lang=js&"
export * from "./NavigatorMain.vue?vue&type=script&lang=js&"
import style0 from "./NavigatorMain.vue?vue&type=style&index=0&id=3fc4a433&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4a433",
  null
  
)

export default component.exports